import UserDropdown from "components/Dropdowns/UserDropdown";
import React, { useEffect } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

export default function Navbar(props) {
  const history = useHistory();
  //Check localstorage null or not
  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  // Retrieve user data from local storage
  const storedUserData = localStorage.getItem("userData");
  let userName = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);

    userName = userData.userName;
  }

  const [navbarOpen, setNavbarOpen] = React.useState(false);
  return (
    <>
      {/* Navbar */}
      <nav
        className="navbar navbar-expand-lg bg-white navbar-light sticky-top py-lg-0 px-lg-5 mb-3  shadow"
        data-wow-delay="0.1s"
      >
        {/* <div className="container px-4 mx-auto flex flex-wrap items-center justify-between"> */}
        {/* Logo Section */}
        {/* <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start"> */}
        <Link to="/admindashboard" className="navbar-brand ms-4">
          <img
            src={require("assets/img/essentials_small.png")}
            alt="Logo not found"
            style={{ width: "200px" }}
          />
        </Link>
        <button
          className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
          type="button"
          onClick={() => setNavbarOpen(!navbarOpen)}
        >
          <i className="fas fa-bars"></i>
        </button>
        {/* </div> */}

        {/* Navbar Toggle Button */}
        <div
          className={
            "lg:flex flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none" +
            (navbarOpen ? " block rounded shadow-lg" : " hidden")
          }
          id="example-navbar-warning"
        >
          {/* Navbar Links */}
          <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
            <li className="flex items-center">
              <Link
                to="/admindashboard"
                className="custnav lg:text-black-800 lg:hover:text-blue-200 text-blueGray-700 px-3 py-3 lg:py-2 flex items-center text-l font-bold"
              >
                <i className=" lg:text-blueGray-200 text-blueGray-200 text-3xl text-lg leading-lg" />
                Dashboard
              </Link>
            </li>

            <li className="flex items-center">
              <Link
                to="/users"
                className="custnav lg:text-black-800 lg:hover:text-blue-200 text-blueGray-700 px-3 py-3 lg:py-2 flex items-center text-l font-bold"
              >
                <i className=" lg:text-blueGray-200 text-blueGray-200 text-3xl text-lg leading-lg" />
                Users
              </Link>
            </li>
            <li className="flex items-center">
              <UserDropdown />
            </li>
          </ul>
        </div>
        {/* </div> */}
      </nav>

      {/* End Navbar */}
    </>
  );
}
